import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

i18n
  // 1. where to load translations from (folder per lang)
  .use(HttpBackend)
  // 2. auto-detect the browser / user language
  .use(LanguageDetector)
  // 3. hook into React
  .use(initReactI18next)
  .init({
    ns: ["common", "legal"],
    fallbackLng: {
      default: ["en-GB"],
      en: ["en-GB"], // remaping plain 'en'
    },
    supportedLngs: ["en", "en-GB", "en-US", "ja"],
    load: "currentOnly",
    debug: false,
    defaultNS: "common",
    interpolation: {
      escapeValue: false, // React already escapes
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json", // default
    },
    // Persist the user's choice deterministically. We deliberately leave
    // `cookie` out of both the lookup order and the caches: a stale
    // `i18nextLng` cookie (e.g. left by the global-entry app on the same
    // domain) was overriding the localStorage selection on every refresh,
    // since the default detection order checks the cookie first while
    // changeLanguage() only writes to localStorage.
    detection: {
      order: ["querystring", "localStorage", "navigator", "htmlTag"],
      lookupQuerystring: "lng",
      caches: ["localStorage"],
    },
  });

export default i18n; // ⇠ just importing this file runs init()
